import template from './creditCardList.html';
import './creditCardList.scss';
import _ from 'lodash';
import moment from 'moment';

class CreditCardListController {
    /*@ngInject*/
    constructor(dataContext, creditCardService, constants, $log, $q, cartService, $uibModal) {
        this.dataContext = dataContext;
        this.displayCardForm = false;
        this.date = moment();
        this.todaysDate = moment();
        this.creditCardService = creditCardService;
        this.constants = constants;
        this.$log = $log;
        this.$uibModal = $uibModal;
        this.$q = $q;
        this.cartService = cartService;
        this.hasCreditCard = false;
        this.hasCreditCardButNoDefaultPayment = false;
    }

    $onInit() {
        this.creditCards = [
            { CreditCardType: 'visa', curClass: 'fpDisabled' },
            { CreditCardType: 'amex', curClass: 'fpDisabled' },
            { CreditCardType: 'mastercard', curClass: 'fpDisabled' },
            { CreditCardType: 'discover', curClass: 'fpDisabled' }
        ];

        this.ccExpMonths = [
            { value: 1, text: '01', disabled: false },
            { value: 2, text: '02', disabled: false },
            { value: 3, text: '03', disabled: false },
            { value: 4, text: '04', disabled: false },
            { value: 5, text: '05', disabled: false },
            { value: 6, text: '06', disabled: false },
            { value: 7, text: '07', disabled: false },
            { value: 8, text: '08', disabled: false },
            { value: 9, text: '09', disabled: false },
            { value: 10, text: '10', disabled: false },
            { value: 11, text: '11', disabled: false },
            { value: 12, text: '12', disabled: false }
        ];

        this.states = [];
        this.billingAddress = null;
        this.cards = [];

        this.isLoading.creditCardList = true;
        this.getAvailableCountries().then(() => {
            this._getCreditCards().then(() => {
                return this.dataContext.account.getCustomerInfo()
                    .then((result) => {
                        this.customer = _.cloneDeep(result.CustomerInformation);
                        this.billingAddress = _.cloneDeep(result.BillingAddress);
                        this.billingAddress = this.fillCountryInfo(this.billingAddress);
                        this.firstName = this.customer.FirstName;
                        this.lastName = this.customer.LastName;

                        this._selectDefaultCard();
                    });
            })
                .finally(() => {
                    this.isLoading.creditCardList = false;
                });
        });
    }

    _getCreditCards() {
        return this.dataContext.customerBillingInfo.getCustomerBillingInfo().then((result) => {
            let customerBillingInfo = _.cloneDeep(result.Data);
            this.cards = _.filter(customerBillingInfo,
                cbi => {
                    return cbi.IsCredit;
                });

        }).finally(() => {
                // If there is no card, only show new credit card info details
                if (!_.isEmpty(this.cards)) {
                    this.hasCreditCard = true;
                } else {
                    this.displayCardForm = true;
                }
            });
    }

    disableCCExpMonths() {
        _.forEach(this.ccExpMonths, (month) => {
            if (moment().year() === this.CcExpYear)
                month.disabled = month.value <= moment().month();
            else
                month.disabled = false;
        });
    }

    displayForm(display) {
        this.displayCardForm = display;
    }

    selectCard(card) {
        this.displayCardForm = false;
        this.selectedCard = _.cloneDeep(card);
        if (_.isFunction(this.onSelected) && !_.isNil(card)) {
            this.onSelected({
                bankCardNumber: 'cbi:' + card.CustomerBillingInfoID,
                bankCardType: card.CreditCardType,
                bankCardMonth: card.CCExp,
                bankCardYear: card.CCExp,
                bankCardCVV2: card.Cvv2,
                cardholderName: card.AccountName,
                billingAddress: this.toShopAddress(this.billingAddress, 'billing')
            });
        }
        // If there is a credit card but no default payment method
        if (!_.isNil(this.selectedCard)) {
            this.hasCreditCardButNoDefaultPayment = true;
        } else {
            this.displayCardForm = true;
        }
    }

    _selectDefaultCard() {
        this.selectCard(_.find(this.cards, { IsDefaultPayment: true }));
    }

    isMatchingCardType(cardType) {
        return this.creditCardService.getCardType(this.newCardNumber) === cardType;
    }

    getCreditCardYears() {
        let years = [];
        let currentDateYear = 2000 + ((new Date()).getYear() - 100);
        for (let x = 0; x <= 10; x++) {
            years.push(currentDateYear + x);
        }
        return years;
    }

    _resetFields() {
        //clear added card info
        this.newCardNumber = '';
        this.CcExpMonth = '';
        this.CcExpYear = '';
    }

    submitNewCard(creditCardForm) {
        this.newBillingAddress = this.toShopAddress(this.billingAddress, 'billing');

        //make all fields dirty and return
        if (!creditCardForm.$valid) {
            _.forEach(creditCardForm.$error.required, (er) => {
                er.$dirty = true;
            });
            return;
        }

        let billingInfo = {
            IsCredit: true,
            CCExp: this.CcExpMonth.text + '/' + this.CcExpYear.toString().substring(2, this.CcExpYear.toString().length),
            AccountNumber: this.newCardNumber,
            IsActive: true,
            IsDeleted: false,
            LastFour: this.newCardNumber.toString().substring(_.size(this.newCardNumber.toString()) - 4, _.size(this.newCardNumber.toString())),
            Line1: this.newBillingAddress.line1,
            Line2: this.newBillingAddress.line2,
            City: this.newBillingAddress.city,
            State: this.newBillingAddress.regionId,
            PostalCode: this.newBillingAddress.postalCode,
            FirstName: this.firstName,
            LastName: this.lastName,
            CustomerBillingInfoID: 0,
            UserCustomerID: null,
            ContactID: 0,
            RoutingNumber: null,
            VerificationNumber: null,
            DateCreated: null,
            CreatedByID: 0,
            PaymentDay: null,
            CreditCardType: null,
            CheckType: null,
            CheckAccountType: null,
            LeadID: null,
            AccountId: 0,
            NickName: '',
            AddressID: 0,
            IsDefaultPayment: true,
            IsDefaultRmr: false,
            Attention: null
        };

        let billingAddress = {
            Address1: _.get(billingInfo, 'Line1', ''),
            Address2: _.get(billingInfo, 'Line2', ''),
            Attention: _.get(billingInfo, 'Attention', ''),
            City: _.get(billingInfo, 'City', ''),
            Country: {
                name: _.get(billingInfo, 'Country.name', ''),
                code3: _.get(billingInfo, 'Country', '')
            },
            Phone: _.get(billingInfo, 'Phone', ''),
            PostalCode: _.get(billingInfo, 'PostalCode', ''),
            State: _.get(billingInfo, 'State', '')
        };

        return this.validateAddress(billingAddress)
            .then((result) => {
                if (!result) {
                    return false;
                }

                this.doesDuplicateExists(billingInfo).then((result) => {
                    if (result) {
                        this.onError({ errorMessage: 'Duplicate Card Exists' });
                        this.$log.error('Error adding credit card:');
                    }
                    else {
                        this.isLoading.creditCardList = true;
                        return this.dataContext.customerBillingInfo.saveCustomerBillingInfo(billingInfo)
                            .then((result) => {
                                if (result && result.Success === false) {
                                    if (result.ErrorMessage.includes("All providers failed")) {
                                        this.onError({
                                            errorMessage:
                                                'Sorry, we encountered an error trying to process your payment. Please try again. If this error persists please contact support.'
                                        });
                                    } else {
                                        this.onError({
                                            errorMessage:
                                                'Sorry, an error occurred when adding the credit card. Please double check your values and try again.'
                                        });
                                    }
                                } 
                                this._getCreditCards().then(() => {
                                    this._selectDefaultCard();
                                    this._resetFields();
                                });
                            })
                            .catch(error => {
                                this.onError({ errorMessage: 'Error adding credit card' });
                                this.$log.error(`Error adding credit card: ${error}`);
                            })
                            .finally(() => {
                                this.isLoading.creditCardList = false;
                            });
                    }
                });
            });
    }

    doesDuplicateExists(newcbi) {
        return this._getCreditCards()
            .then(() => {
                this._selectDefaultCard();
                let cardCheck = _.some(this.cards, (card) => {
                    return (newcbi.CCExp === card.CCExp && newcbi.LastFour === card.LastFour);
                });
                return cardCheck;
            });
    }
    validateAddress(address) {
        let formattedAddress = {
            Address1: address.Address1,
            Address2: address.Address2,
            City: address.City,
            PostalCode: address.PostalCode,
            State: address.State
        };

        return this.dataContext.address.validateAddress(formattedAddress)
            .then((response) => {
                if (!this.dataContext.address.isValidResponse(response)) {
                    let returnedAddress = {
                        Address1: address.Address1,
                        Address2: address.Address2,
                        City: response.City,
                        PostalCode: response.PostalCode,
                        State: response.StateAbrev
                    };

                    let modalInstance = this.$uibModal.open({
                        template: '<fp-address-validation-modal config="config"></fp-address-validation-modal>',
                        controller: ($scope) => {
                            'ngInject';
                            $scope.config = {
                                data: address,
                                close: modalInstance.close,
                                dismiss: modalInstance.dismiss,
                                returnedAddress: returnedAddress
                            };
                        }
                    });

                    return modalInstance.result.then((result) => {
                        if (_.isNil(result)) {
                            this.isEditMode = false;
                            return false;
                        } else {
                            if (address.State !== result.State || address.City !== result.City) {
                                address.State = result.State;
                                address.City = result.City;
                            }
                            return true;
                        }
                    });
                } else {
                    return true;
                }
            });
    }

    fillCountryInfo(address) {
        if (_.isString(address.State)) {
            address.State = _.find(this.states, (s) => {
                return s.code === address.State;
            });
        }

        if (_.isNil(address.Country)) {
            address.Country = address.State.country;
        }

        return address;
    }

    toShopAddress(fpAddress, addressType) {
        return {
            city: fpAddress.City,
            firstName: this.customer.FirstName,
            lastName: this.customer.LastName,
            countryCode: fpAddress.Country.code3,
            countryName: fpAddress.Country.name,
            line1: fpAddress.Address1,
            line2: fpAddress.Address2,
            postalCode: fpAddress.PostalCode,
            regionId: fpAddress.State.code,
            regionName: fpAddress.State.name,
            type: addressType
        };
    }

    getAvailableCountries() {
        return this.cartService.getCountries()
            .then((response) => {
                this.countries = _.filter(response.data, (c) => {
                    return _.some(this.constants.supportedCountries, (sc) => sc === c.code2);
                });
                return this.countries;
            })
            .then((countries) => {
                let temp = [];

                return this.$q.all(_.map(countries, (c) => {
                    return this.getCountryRegions(c)
                        .then((states) => {
                            _.each(states, (s) => {
                                s.country = c;
                            });
                            temp = _.concat(temp, states);
                        });
                }))
                    .finally(() => {
                        this.states = temp;
                    });
            });
    }

    getCountryRegions(country) {
        return this.cartService.getCountryRegions(country.code3)
            .then((response) => {
                return response.data;
            });
    }
}

export default {
    template: template,
    bindings: {
        onSelected: '<',
        onError: '&',
        isLoading: '='
    },
    controller: CreditCardListController
};